import { SettingsTab } from './SettingsTab';

export class SettingsPageSelectedTab {
    public tab: SettingsTab;
    public tabIndex: number = 0;
    public tabId: string;
}